import { createTabSystem, GetTabsProps } from 'common/types/tabsV2';
import { TabV2Item } from 'common/ui/TabsV2';

const candidateProfileTabs = [
  'Profile',
  'Invited',
  'Applied',
  'Other campaigns',
  'Documents'
] as const;

export type CandidateProfileTab = (typeof candidateProfileTabs)[number];

const candidateTabSystem = createTabSystem(candidateProfileTabs);

type GetCandidateProfileTabsProps = GetTabsProps<CandidateProfileTab>;

export const getCandidateProfileTabs = (
  props: GetCandidateProfileTabsProps
): TabV2Item[] => {
  return candidateTabSystem.createTabs(props);
};
